
const formatPrice = (price: number, maximumFractionDigits: number=2) => {
    return price.toLocaleString('en-AU', {currency: 'AUD', style: 'currency', maximumFractionDigits: maximumFractionDigits});
}

const formatInterval = (interval: string): string => {
    interval = interval.toLowerCase()
    const options: {[key: string]: string} = {
        "month": "Monthly",
        "annual": "Annually",
        "year": "Yearly",
    }
    return options[interval]
}


const sentenceCase = (str: string) => {
    const sentenceCase = str
      .split(" ")
      .map((w) => w[0].toUpperCase() + w.substring(1).toLowerCase())
      .join(" ");
    return sentenceCase;
  };

const humanizeNumber = (number: number) => {
  if (number < 1000) {
    return number.toString();
  }

  const units = ["K", "M", "B", "T"];
  let unitIndex = -1;

  while (number >= 1000 && unitIndex < units.length - 1) {
    number /= 1000;
    unitIndex++;
  }

  return number.toFixed(1) + units[unitIndex];
};

export { formatInterval, formatPrice, humanizeNumber, sentenceCase };

